/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_service_portal': {
    width: 20,
    height: 21,
    viewBox: '0 0 20 21',
    data: '<defs><path pid="0" d="M2 1h20v3H2V1zm0 18h20v3H2v-3zm2.5-9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm15 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM12 10a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm-7.5 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm15 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM12 16a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" id="svgicon_icon_service_portal_a"/></defs><g transform="translate(-2 -1)" _fill="none" fill-rule="evenodd"><mask id="svgicon_icon_service_portal_b" _fill="#fff"><use xlink:href="#svgicon_icon_service_portal_a"/></mask><use _fill="#1C2024" xlink:href="#svgicon_icon_service_portal_a"/><g mask="url(#svgicon_icon_service_portal_b)" _fill="#586A92"><path pid="1" d="M0 0h24v24H0z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/icon_service_portal.js